import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { ContractInfo } from '~/features/ContractInfo';
import styles from './styles.module.scss';

/**
 * ご契約情報 Screen
 *
 * セクション（会社情報 / プラン情報 / お支払い方法 / ご担当者情報 / ご請求先情報）の
 * 並びと区切りは ContractInfo Feature 側が持つ。
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader variant='title' title='ご契約情報' />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <ContractInfo />
        </Suspense>
      </main>
    </div>
  </div>
);
